import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TopHeader } from '../components/layout/TopHeader';
import { SideNav } from '../components/layout/SideNav';
import { ToastHost } from '../components/common/ToastHost';
import { PostAuthRouteValidator } from '../rbac/guards';

export function AppShell() {
  const { t, i18n } = useTranslation();

  return (
    <div className="app-full">
      <PostAuthRouteValidator />
      <TopHeader subtitle={t('header.intranetPortal')} />
      <ToastHost />
      <div className="app-body">
        <SideNav />
        <main className="mc" role="main">
          <Outlet key={i18n.language} />
        </main>
      </div>
    </div>
  );
}
